module.exports = __webpack_public_path__ + "ed08dd112a388df8ad6746a57641f377.pdf";